export default __webpack_public_path__ + "static/media/videoGames.3ae9d044.jpeg";